import type { CDedicatedDescriptivePageTranslations } from "./pl";

export const de: CDedicatedDescriptivePageTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",
  emptyContent: "Diese Seite enthält noch keinen Inhalt.",
};
